import React from 'react';
import {
  Box,
  Card,
  CardContent,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import { Info } from '@mui/icons-material';
import { BrandButton } from '../button';
import { acme } from '../../theme/acmeTheme';
import { dnsRecordInstructions } from './dnsRecordInstructions';

const DnsRecordInfoDialog = ({ open, onClose, recordType }) => {
  const instruction = recordType ? dnsRecordInstructions[recordType] : null;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>
        <Box display="flex" alignItems="center" gap={1}>
          <Info sx={{ color: acme.colors.brand }} />
          <Typography variant="h6">{instruction?.title}</Typography>
          <Chip
            label={instruction?.type}
            size="small"
            sx={{ backgroundColor: acme.colors.brand, color: acme.colors.brandForeground }}
          />
        </Box>
      </DialogTitle>
      <DialogContent dividers>
        {instruction && (
          <>
            <Typography variant="body1" sx={{ mb: 3, fontStyle: 'italic' }}>
              {instruction.description}
            </Typography>

            <Card variant="outlined" sx={{ mb: 3 }}>
              <CardContent>
                <Typography variant="h6" gutterBottom sx={{ color: acme.colors.brand }}>
                  📋 Step-by-Step Instructions
                </Typography>
                {instruction.steps.map((step, index) => (
                  <Typography key={index} variant="body2" sx={{ mb: 1 }}>
                    {step}
                  </Typography>
                ))}
              </CardContent>
            </Card>

            <Card variant="outlined" sx={{ backgroundColor: '#f8f9fa' }}>
              <CardContent>
                <Typography variant="h6" gutterBottom sx={{ color: '#f57c00' }}>
                  💡 Important Notes
                </Typography>
                {instruction.notes.map((note, index) => (
                  <Typography key={index} variant="body2" sx={{ mb: 1 }}>
                    {note}
                  </Typography>
                ))}
              </CardContent>
            </Card>

            <Box sx={{ mt: 3, p: 2, backgroundColor: '#e8f5e8', borderRadius: 1 }}>
              <Typography variant="subtitle2" sx={{ fontWeight: 'bold', color: '#2e7d32', mb: 1 }}>
                🔧 Common DNS Providers
              </Typography>
              <Typography variant="body2" component="div">
                • <strong>Cloudflare:</strong> Dashboard → DNS → Records → Add record
                <br />
                • <strong>GoDaddy:</strong> Domain Manager → DNS → Manage Zones → Add
                <br />
                • <strong>Namecheap:</strong> Domain List → Manage → Advanced DNS → Add New Record
                <br />
                • <strong>Route 53:</strong> Hosted Zones → Select Domain → Create Record Set
              </Typography>
            </Box>
          </>
        )}
      </DialogContent>
      <DialogActions>
        <BrandButton onClick={onClose}>Got it!</BrandButton>
      </DialogActions>
    </Dialog>
  );
};

export default DnsRecordInfoDialog;
